import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../configs/environment';
import { PaymentPPAInfo } from '../../utils/shared-constants';
import { map, switchMap, take } from 'rxjs/operators';

@Injectable()
export class PaymentService {
	private url = environment.backendApiUrl + '/spaq';

	constructor(private db: AngularFireDatabase, private auth: AngularFireAuth, private store: Store<any>, private http: HttpClient) {}

	addPPA(data: PaymentPPAInfo): Observable<any> {
		const newData = {
			...data,
			financialInstitutionId: data.financialInstitutionId['text']
		};
		return this.http.post(`${this.url}/bankInformation`, newData);
	}

	deleteCC(): Observable<any> {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => this.db.object(`/user/${u.uid}/payment/cards`).remove())
		);
	}

	getPPA(): Observable<any> {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => this.db.object(`/user/${u.uid}/payment/ppa`).valueChanges())
		);
	}

	getPayment(): Observable<any> {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => this.db.object(`/user/${u.uid}/payment`).valueChanges())
		);
	}

	getPaymentsHistory(): Observable<any[]> {
		return this.auth.user.pipe(
			take(1),
			switchMap(u => this.db.list(`/user/${u.uid}/payments`).snapshotChanges()),
			map(changes => changes.map((c: any) => ({ key: c.payload.key, ...c.payload.val() })))
		);
	}

	requestReceipt(paymentId: string): Observable<any> {
		return this.http.post(`${this.url}/payments/${paymentId}/receipt`, {});
	}
}
